export const getSummaryDescription = (creationDate, username) => {
  return `Uploaded ${creationDate} by ${username}`;
};
